export default [
   "Church", 
   "Burial Grounds",
   "Reception"
  ];